import React, { useContext, useEffect, useState, useRef } from "react";
import "./Dashboard.css";
import DashboardWithChatCard from "../../Common/Card/DashboardWithChatCard";
import chatsectionicon from "../../Assets/Images/chatsectionicon.svg";
import createcandidateicon from "../../Assets/Images/createcandidateicon.png";
import createcandidatedarkicon from "../../Assets/Images/createcandidate-dark-icon.png";
import createjobicon from "../../Assets/Images/createjobicon.png";
import createjobdarkicon from "../../Assets/Images/createjob-dark-icon.png";
import findcandidatesicon from "../../Assets/Images/findcandidatesicon.png";
import findcandidatesdarkicon from "../../Assets/Images/dark-paperclip.png";
import analyzeresumeicon from "../../Assets/Images/analyzeresumeicon.png";
import analyzeresumedarkicon from "../../Assets/Images/dark-paperclip.png";
import bgimage from "../../Assets/Images/dashboard-backgroundimage.png";
import "../AI-Driven-Screening/AiDrivenScreening.css";
import "../../Common/Card/DashboardCard.css";
import dashboardIcon from "../../Assets/Images/dashboard-header-icon.svg";
import { useNavigate } from "react-router-dom";
import { DynamicContext } from "../../Context/DynamicContext.js";
import DashboardDarkIcon from "../../Assets/Images/dashboard-header-darkicon.svg";
import singleCepheaIcon from "../../Assets/Images/VybogTAL-Icon.svg";
import Button from "../../Common/Button/Button.js";
import {
  VYLABS_BASE_URL,
  LIST_MEMEBERS_OF_TENANT,
  GET_TENANT_DETAILS,
} from "../../helper/url_helper.js";
import { get } from "../../helper/Api_helper.js";
import { TENANT_CORE_API_KEY } from "../../Tenant-Config/TenantConfig.js";
import warningIcon from "../../Assets/Images/warning-3d-icon.png";
import TrialSnackbar from "./FreeTrialToast.js";
import addMemberImage from "../../Assets/Images/add-member-image.png";

function Dashboard() {
  const {
    isDarkMode,
    userDetails,
    setUploadResumeViewOpen,
    subscriptionDetails,
    setHideCandidatesHeader,
    hasSubscription,
    tenantDetails,
    setTenantDetails,
    AdminAccess,
    MemberAccess,
    UnAssociatedAccess,
  } = useContext(DynamicContext);
  const navigate = useNavigate();
  const [showAddMemberBanner, setShowAddMemberBanner] = useState(false);
  const [tenantFetchError, setTenantFetchError] = useState(false);
  const [showTrialSnackbar, setShowTrialSnackbar] = useState(false);
  const [daysLeftInTrial, setDaysLeftInTrial] = useState(0);

  const hasShownSnackbarRef = useRef(false);
  const calculateDaysLeft = () => {
    if (
      subscriptionDetails?.status === "trialing" &&
      subscriptionDetails?.trial_end
    ) {
      const trialEnd = new Date(subscriptionDetails.trial_end);
      const now = new Date();
      const timeDiff = trialEnd.getTime() - now.getTime();
      const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return Math.max(0, daysLeft);
    }
    return 0;
  };
  useEffect(() => {
    if (
      subscriptionDetails?.status === "trialing" &&
      !hasShownSnackbarRef.current
    ) {
      const daysLeft = calculateDaysLeft();
      setDaysLeftInTrial(daysLeft);

      if (daysLeft > 0) {
        setShowTrialSnackbar(true);
        hasShownSnackbarRef.current = true;
      }
    }
  }, [subscriptionDetails]);

  const handleCloseSnackbar = () => {
    setShowTrialSnackbar(false);
  };

  useEffect(() => {
    return () => {
      hasShownSnackbarRef.current = false;
    };
  }, []);

  const handleCandidateNavigate = () => {
    navigate("/candidates-list");
    setHideCandidatesHeader(false);
    setUploadResumeViewOpen(true);
  };

  const fetchMembers = async () => {
    if (!AdminAccess) {
      setShowAddMemberBanner(false);
      return;
    }

    try {
      const requestConfig = {
        headers: {
          "X-API-Key": TENANT_CORE_API_KEY,
        },
      };
      const response = await get(
        VYLABS_BASE_URL,
        `${LIST_MEMEBERS_OF_TENANT}?tenant_id=${userDetails?.tenant_id}&offset=0&limit=50`,
        requestConfig,
      );
      if (response?.users && Array.isArray(response.users)) {
        const hasAdmin = response.users.some(
          (user) => user?.user?.role === "ADMIN",
        );
        const hasMember = response.users.some(
          (user) => user?.user?.role === "MEMBER",
        );
        setShowAddMemberBanner(hasAdmin && !hasMember);
      } else {
        setShowAddMemberBanner(false);
      }
    } catch (err) {
      console.error(
        "Dashboard LIST_MEMEBERS_OF_TENANT Error fetching members:",
        err,
      );
      setShowAddMemberBanner(false);
    }
  };

  const fetchTenantDetails = async () => {
    try {
      const requestConfig = {
        headers: {
          "X-API-Key": TENANT_CORE_API_KEY,
        },
      };
      const response = await get(
        VYLABS_BASE_URL,
        GET_TENANT_DETAILS,
        requestConfig,
      );
      localStorage.setItem("tenant", JSON.stringify(response));
      setTenantDetails(response?.tenant || null);
      setTenantFetchError(false);
    } catch (err) {
      console.error("Dashboard GET_TENANT_DETAILS Error:", err);
      if (err.response?.status === 403) {
        setTenantFetchError(true);
      } else {
        setTenantFetchError(false);
      }
      setTenantDetails(null);
    }
  };

  useEffect(() => {
    if (AdminAccess) {
      fetchMembers();
    } else {
      setShowAddMemberBanner(false);
    }
    fetchTenantDetails();
  }, [AdminAccess]);

  const handleAddMemberNavigate = () => {
    navigate("/settings/users", { state: { openAddMemberDialog: true } });
  };
  const handleStartTrialNavigate = () => {
    navigate("/settings/subscriptions");
  };
  return (
    <>
      <div className="dashboard-container">
        {showTrialSnackbar && (
          <TrialSnackbar
            daysLeft={daysLeftInTrial}
            onClose={handleCloseSnackbar}
          />
        )}
        <div className="dashboard-header-main-container">
          <div className="header-inner-container">
            <div className="header-icon-title-container">
              <img
                alt=""
                src={isDarkMode ? DashboardDarkIcon : dashboardIcon}
                className="header-title-icon"
              />
              <h2 className="header-container">Dashboard</h2>
            </div>
            <div
              className="cephea-span-container-tenant-name"
              style={{ marginTop: "10px" }}
            >
              <img
                alt=""
                className="single-cephea-icon"
                src={singleCepheaIcon}
              />
              {tenantFetchError ? (
                <h3 className="VybogTAL-tentnt-text">Hi, this is VybogTAL!</h3>
              ) : (
                <h3 className="cephea-tentnt-text">{tenantDetails?.name}</h3>
              )}
            </div>
          </div>
        </div>

        <div className="dashboard-page-outer-container">
          {AdminAccess && showAddMemberBanner && (
            <div className="add-member-banner">
              <img
                alt="Add Member Icon"
                src={addMemberImage}
                className="banner-icon"
              />
              <div className="banner-content">
                <h3>Add Member!</h3>
                <p>
                  As an admin, you can add members to your organization. Expand
                  your team and boost productivity right now!
                </p>
              </div>
              <Button label="Add Member" event={handleAddMemberNavigate} />
            </div>
          )}
          <div className="custom-container">
            <div
              className="layout-wrapper"
              style={{
                backgroundImage: `url(${bgimage})`,
              }}
            >
              <div className="left-section">
                <div className="welcome-text">
                  <h2 className="company-title">Welcome</h2>
                  <h1 style={{ whiteSpace: "nowrap", fontSize: "40px" }}>
                    {userDetails?.first_name} {userDetails?.last_name} !
                  </h1>
                </div>
                {UnAssociatedAccess ? (
                  <div className="unassociated-dashboard-container">
                    <p className="description">
                      Since you are not affiliated with any organization, please
                      ask your administrator to add you to their organization so
                      that you can start using VybogTAL.
                    </p>
                  </div>
                ) : (
                  <>
                    {!hasSubscription ? (
                      <div className="subscription-warning-banner">
                        <div className="banner-content">
                          {AdminAccess && (
                            <p className="description">
                              Your organization's subscription has ended. Please
                              renew your plan in the Subscription Settings to
                              continue using all VybogTAL features.
                            </p>
                          )}
                          {MemberAccess && (
                            <p className="description">
                              Your organization's subscription has ended. Please
                              contact your administrator to renew it and restore
                              full access to VybogTAL features.
                            </p>
                          )}
                        </div>
                      </div>
                    ) : (
                      <p className="description">
                        Get started with VybogTAL - create candidates, post
                        jobs, analyze resumes, or find top talent with a click.
                      </p>
                    )}
                  </>
                )}
              </div>
              <div className="icon-container">
                <img src={chatsectionicon} alt="Object Icon" className="icon" />
              </div>
            </div>
          </div>
          {!UnAssociatedAccess &&
            !hasSubscription &&
            subscriptionDetails?.status !== "paused" && (
              <div className="subscription-alert-banner free-trial-banner">
                <div className="alert-icon">
                  <img src={warningIcon} alt={"warningIcon"} />
                </div>
                <div className="alert-text">
                  <strong>
                    Start Your Free Trial (No credit card required)!
                  </strong>{" "}
                  Get 14 days of full access to all VybogTAL features.
                  <Button
                    label="Activate Trial"
                    event={handleStartTrialNavigate}
                    backgroundColor="#2e7d32"
                  />
                </div>
              </div>
            )}
          {subscriptionDetails?.status === "paused" && (
            <div className="subscription-alert-banner">
              <div className="alert-icon">
                <img src={warningIcon} alt={"warningIcon"} />
              </div>
              <div className="alert-text">
                <strong>Subscription Expired!</strong> Please renew your
                subscription to continue using VybogTAL's features.
              </div>
            </div>
          )}
          {UnAssociatedAccess && (
            <div className="subscription-alert-banner">
              <div className="alert-icon">
                <img src={warningIcon} alt={"warningIcon"} />
              </div>
              <div className="alert-text">
                <strong>Account Not Associated!</strong> You are not affiliated
                with any organization. Please contact your administrator to be
                added to an organization.
              </div>
            </div>
          )}
          {UnAssociatedAccess || !hasSubscription ? null : (
            <div className="cards-container">
              <DashboardWithChatCard
                iconSrc={
                  isDarkMode ? createcandidatedarkicon : createcandidateicon
                }
                title="Create Candidate"
                shortDescription="Enter candidate details, upload resumes, and track their progress - all in one centralized pipeline."
                handleCardOnClick={handleCandidateNavigate}
              ></DashboardWithChatCard>
              <DashboardWithChatCard
                iconSrc={isDarkMode ? createjobdarkicon : createjobicon}
                title={MemberAccess ? "Explore Jobs" : "Create Job"}
                shortDescription="Define job requirements, set qualifications, and start receiving applications instantly."
                handleCardOnClick={() => {
                  MemberAccess
                    ? navigate("/jobs-list")
                    : navigate("/jobs-list", {
                        state: { openCreateJob: true },
                      });
                }}
              ></DashboardWithChatCard>

              <DashboardWithChatCard
                iconSrc={isDarkMode ? analyzeresumedarkicon : analyzeresumeicon}
                title="Analyze Resumes"
                shortDescription="Upload resumes to automatically extract skills, experience, and match them with relevant job openings."
                handleCardOnClick={() => navigate("/resume-parser")}
              ></DashboardWithChatCard>

              <DashboardWithChatCard
                iconSrc={
                  isDarkMode ? findcandidatesdarkicon : findcandidatesicon
                }
                title="Find Candidates"
                shortDescription="Use powerful search to find ideal candidates based on skills, experience, and other key criteria."
                handleCardOnClick={() => navigate("/candidates-list")}
              ></DashboardWithChatCard>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Dashboard;
